import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-pane" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginForm = _resolveComponent("LoginForm")!
  const _component_ChangePasswordForm = _resolveComponent("ChangePasswordForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isInLoginMode)
      ? (_openBlock(), _createBlock(_component_LoginForm, {
          key: 0,
          "system-mode": _ctx.systemMode,
          "error-message": _ctx.errorMessage,
          onLogin: _cache[0] || (_cache[0] = ($event: any) => (_ctx.login($event)))
        }, null, 8, ["system-mode", "error-message"]))
      : (_openBlock(), _createBlock(_component_ChangePasswordForm, {
          key: 1,
          policy: _ctx.passwordPolicy,
          "error-message": _ctx.errorMessage,
          onChangePassword: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changePassword($event)))
        }, null, 8, ["policy", "error-message"]))
  ]))
}